import React from 'react';
import { duration, timeframe } from '../../utils/broadcast';
import { Clock } from '../../utils';
import PreviewIcon from '../library/preview-icon.jsx';
import BroadcastStartStopTime from '../library/broadcast-start-stop-time.jsx';

function buildBroadcastAriaLabel(broadcast) {
  var parts = [broadcast.name];
  var t = timeframe(broadcast);
  if (t === 'current') {
    parts.push('Live now');
  } else if (t === 'future') {
    parts.push('Starts ' + Clock.formatFull(Clock.parse(broadcast.starts_at)));
  } else if (broadcast.starts_at) {
    parts.push(Clock.formatFull(Clock.parse(broadcast.starts_at)));
  }
  var d = duration(broadcast);
  if (d) parts.push(d);
  if (broadcast.description) parts.push(broadcast.description);
  return parts.join(', ');
}

export default function BroadcastListItem(props) {
  const { broadcast, selected, onSelect, defaultPoster } = props;
  const className = `boxcast-playlist-item boxcast-selectable ${
    selected ? 'boxcast-selected' : ''
  }`;

  const image = broadcast.poster ? broadcast.poster : broadcast.preview || defaultPoster;
  const ariaLabel = buildBroadcastAriaLabel(broadcast);

  return (
    <li className={className}>
      <PreviewIcon
        image={image}
        duration={duration(broadcast)}
        timeframe={timeframe(broadcast)}
        onClick={() => onSelect(broadcast, true)}
      />
      <div className="boxcast-playlist-item-meta">
        <h3>
          <a
            href="#"
            aria-label={ariaLabel}
            onClick={(e) => {
              e.preventDefault();
              onSelect(broadcast);
            }}
          >
            {broadcast.name}
          </a>
        </h3>
        <p>{broadcast.description}</p>
        <p>
          <BroadcastStartStopTime broadcast={broadcast} mode="inline" />
        </p>
      </div>
    </li>
  );
}
